import React from 'react'
import './blog-review.css'
import BlogReviewCard from '../BlogReviewCard/BlogReviewCard'
import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'

const BlogReview = (props) => {

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    const [blogs, setBlogs] = React.useState([])

    React.useEffect(() => {
        getBlogs()
    },[])

    const getBlogs = async () => {
        Axios.get(`${baseUrl}/blogstoreview`, myHeader)
        .then(res => { setBlogs(res.data) })
        .catch(err => { console.log(err) })
    }

    const reviewTheBlog = (blog) => {
        props.setCurrentView('blogtoreview')
        props.setBlogToReview(blog)
    }
    if(props.personal) {
        return (
            <div>
            <div className="blogs-to-review-wrapper">
            <h3>My Drafts</h3>
                    {blogs.map((blog) => blog.Preview.Author === props.userData.Name || blog.Preview.Author === 'Gloria Conroy' || blog.Preview.Author === 'Charlie Fergson' || blog.Preview.Author === 'Marie Bergman' && <BlogReviewCard key={blog.Preview.Id} blog={blog} reviewTheBlog={reviewTheBlog} />)}
            </div>
        </div>
        )
    } else {
        return (
            <div>
                <div className="blogs-to-review-wrapper">
                    <h3>To Review</h3>
                    {blogs.map((blog) => blog.Status === 'submitted' && <BlogReviewCard key={blog.Preview.Id} blog={blog} reviewTheBlog={reviewTheBlog} />)}
                    <h3>Published</h3>
                    {blogs.map((blog) => blog.Status === 'published' && <BlogReviewCard key={blog.Preview.Id} blog={blog} reviewTheBlog={reviewTheBlog} />)}
                </div>
            </div>
        )
    }
}
export default BlogReview